import { Form } from 'factorial-form'

class BulkEdit extends Form {
  constructor(values: { [key: string]: string | number | number[] }) {
    const {
      manager_id,
      location_id,
      timeoff_policy_id,
      timeoff_manager_id,
      regular_access_starts_on,
      teams_ids,
      legal_entity_id,
      permission_group_id,
      employee_group_id,
      ...customFieldKeys
    } = values

    super(values, {
      manager_id: 'number',
      location_id: 'number',
      timeoff_policy_id: 'number',
      timeoff_manager_id: 'number',
      regular_access_starts_on: 'date',
      teams_ids: 'any',
      legal_entity_id: 'number',
      permission_group_id: 'number',
      employee_group_id: 'number',
      ...Object.fromEntries(Object.entries(customFieldKeys).map(([key]) => [key, 'any'])),
    })
  }
}

export default BulkEdit
